import React from 'react';
import localStorageHelper from './localStorageHelper'
import {createBrowserHistory} from "history";
import {Router, Route, Switch, Redirect} from "react-router-dom";
// @material-ui/icons
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import AddAlert from "@material-ui/icons/AddAlert";
// core components
import Snackbar from "./components/Snackbar/Snackbar.jsx";
import Login from './views/Login/Login'
import OneOpenReport from './views/Reports/OneOpenReport'
import LockScreen from './views/LockScreen/LockScreen'
import ErrorBoundary from './views/Error'
import "./assets/scss/material-dashboard-pro-react.css?v=1.2.0";
import indexRoutes from "./routes/index.jsx";
import clinicDashBoardRoutes from "./routes/clinicDasboard.jsx";
import Auth from "./Auth.jsx";
import {
    dashboardRouter
} from './util/globalHelper';

const hist = createBrowserHistory();


class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tc: false,
            message: '',
            color: 'info',
            showNotification: false,
        };
        this.NotificationDone = this.NotificationDone.bind(this);
        this.generateNotification = this.generateNotification.bind(this);
        this.showNotification = this.showNotification.bind(this);
    }

    NotificationDone() {
        this.setState({message: ''});
    }

    componentDidMount() {
        if (!window.location.pathname.includes("login")) {
            // localStorage.setItem("last_url", window.location.pathname)
        }
        if (Auth.isAuthenticated() && window.location.pathname === "/") {
            window.location.pathname = dashboardRouter(`/dashboard`)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.reloadState !== nextProps.reloadState && nextProps.reloadState) {
            window.location.reload()
        }
        if (this.props.serverError !== nextProps.serverError && nextProps.serverError) {
            this.generateNotification({message: "Something went wrong/Session Expired Login Again!", color: "danger"})
        }
    }

    generateNotification(msgcolor) {
        this.setState({message: msgcolor.message}, () => {
            this.setState({color: msgcolor.color}, () => {
                this.setState({showNotification: true}, () => {
                    this.showNotification("tc")
                })
            })
        });
    }

    showNotification(place) {
        if (!this.state[place]) {
            var x = [];
            x[place] = true;
            this.setState(x);
            // use this to make the notification autoclose
            setTimeout(
                function () {
                    x[place] = false;
                    this.setState(x);
                    this.NotificationDone();
                }.bind(this),
                4000
            );
        }
    }


    render() {
        return (
            <div>
                <Snackbar
                    place="tc"
                    color={this.state.color}
                    icon={AddAlert}
                    message={this.state.message}
                    open={this.state.tc}
                    closeNotification={() => this.setState({tc: false})}
                    close
                />
                <Router history={hist}>
                    <Switch>
                        <ErrorBoundary>
                            <Route path="/login" render={(props) =>
                                <Login {...props} generateNotification={this.generateNotification}/>}/>
                            <Route path="/patient/report/view/:id" render={(props) =>
                                <OneOpenReport {...props} generateNotification={this.generateNotification}/>}/>
                            <Route path="/lock-screen" render={(props) =>
                                <LockScreen {...props} generateNotification={this.generateNotification}/>}/>
                            {window && window.location.pathname.includes("/patient/report/view")
                                ? null : Auth.isSuperAdminDashboard() ?
                                    indexRoutes.map((prop, key) => {
                                        if (!window.location.pathname.includes("login") && localStorage.getItem("superAdmin") === undefined) {
                                            localStorage.setItem("last_url", window.location.pathname)
                                        }
                                        return Auth.isAuthenticated() ? <Route path={prop.path} render={(props) => (
                                                <prop.component {...props} generateNotification={this.generateNotification}
                                                />)} key={key}/>
                                            : <Redirect key={Math.random()} to="/login"/>;
                                    }) : clinicDashBoardRoutes.map((prop, key) => {
                                        if (!window.location.pathname.includes("login") && localStorage.getItem("superAdmin") === undefined) {
                                            localStorage.setItem("last_url", window.location.pathname)
                                        }
                                        return Auth.isAuthenticated() ? <Route path={prop.path} render={(props) => (
                                                <prop.component {...props} generateNotification={this.generateNotification}
                                                />)} key={key}/>

                                            : <Redirect key={Math.random()} to="/login"/>;
                                    })}
                        </ErrorBoundary>
                    </Switch>
                </Router>
            </div>
        );
    }
}

const mapStateToProps = ({global}) => ({
    serverError: global.serverError,
    reloadState: global.reloadState
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.jsx